/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Add from './Add/index'
import Confirm from './Confirm/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/ReferralsSection/New"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Add'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Add'}>
<Add
  viewPath={`${viewPath}/Add`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Confirm'}>
<Confirm
  viewPath={`${viewPath}/Confirm`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}